import { makeStyles } from "@material-ui/core/styles";
import { deepOrange } from "@material-ui/core/colors";
const drawerWidth = 240;

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    backgroundColor: "#FFF",
    boxShadow: "0 4px 5px 0 rgba(0, 0, 0, 0.1)",
    zIndex: theme.zIndex.drawer + 1,
    "& > .MuiToolbar-root": {
      minHeight: 60,
      [theme.breakpoints.up("md")]: {
        minHeight: 70,
      },
      [theme.breakpoints.up("lg")]: {
        minHeight: 80,
      },
    },
  },
  adminModuleHeader: {
    backgroundColor: "#000",
  },
  logo: {
    height: 40,
    [theme.breakpoints.up("sm")]: {
      height: 50,
    },
    [theme.breakpoints.up("md")]: {
      height: 60,
    },
    [theme.breakpoints.up("lg")]: {
      height: 64,
    },
  },
  appBarShift: {
    width: "100%",
  },
  menuButton: {
    marginRight: 10,
  },
  menuButtonAdmin: {
    color: '#fff',
  },
  hide: {
    display: "none",
  },
  drawer: {
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    border: 0,
    width: "93px",
    overflow: "visible",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      width: `${drawerWidth}px`,
      zIndex: 1,
    },
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    border: 0,
    width: 0,
    [theme.breakpoints.up("sm")]: {
      width: "93px",
    },
  },
  contentMap: {},
  contentInnerMap: {},
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    minHeight: 60,
    margin: '0px 17px',
    [theme.breakpoints.up("md")]: {
      minHeight: 70,
    },
    [theme.breakpoints.up("lg")]: {
      minHeight: 80,
    },
  },
  content: {
    flex: "0 0 calc(100% - 0px)",
    width: "calc(100% - 0px)",
    maxWidth: "calc(100% - 0px)",
    padding: theme.spacing(0),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(0, 3),
    },
    [theme.breakpoints.up("sm")]: {
      flex: "0 0 calc(100% - 93px)",
      width: "calc(100% - 93px)",
      maxWidth: "calc(100% - 93px)",
    },
  },
  contentWithoutSideBar: {
    flex: "0 0 100%",
    padding: theme.spacing(0),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(0, 3),
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  contentWithoutSideBarInner: {
    padding: theme.spacing(0, 2, 1),
  },
  contentInner: {
    padding: theme.spacing(4, 2, 1),
  },
  list: {
    position: "absolute",
    backgroundColor: "#000",
    width: "93px",
    paddingTop: "0!important",
    top: 60,
    height: "calc(100% - 60px)",
    [theme.breakpoints.up("md")]: {
      top: 70,
      height: "calc(100% - 70px)",
    },
    [theme.breakpoints.up("lg")]: {
      top: 80,
      height: "calc(100% - 80px)",
    },
  },
  linkClosed: {
    width: "93px",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "& .MuiListItemText-root": {
      opacity: 0,
      transition: theme.transitions.create(["opacity", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
  linkOpened: {
    width: `${drawerWidth}px`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "& .MuiListItemText-root": {
      opacity: 1,
      transition: theme.transitions.create(["opacity", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: "350ms",
      }),
    },
  },
  listOpen: {
    width: `${drawerWidth}px`,
    boxShadow: "0px 5px 8px rgb(0 0 0 / 0.3)",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  imageIcon: {
    margin: "0.5em 0",
    marginLeft: "1.2em",
  },
  iconRoot: {
    textAlign: "center",
  },
  iconText: {
    color: theme.palette.primary.main,
  },
  paragraph: {
    marginBottom: "0",
  },
  border: {
    borderLeft: "1px solid rgba(130,145,169,0.53)",
    borderRight: "1px solid rgba(130,145,169,0.53)",
  },
  notification: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  notificationDot: {
    position: "absolute",
    top: "-10%",
    left: "48%",
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#ffffff",
    zIndex: 1,
  },
  notificationDotInner: {
    width: 6,
    height: 6,
    borderRadius: 3,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
  },
  notificationDotEnable: {
    backgroundColor: theme.palette.secondary.main,
  },
  notificationIcon: {

  },
  avatar: {
    fontSize: ".85rem",
    fontWeight: 500,
    display: "flex",
    textTransform: 'uppercase',
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]) + "!important",
    backgroundColor: deepOrange[500] + "!important",
    paddingTop: "4px",
  },
  headerRightMenu: {
    backgroundColor: "transparent!important",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "300px",
    "&.MuiButtonBase-root": {
      minHeight: 40,
      padding: 0,
    },
  },
  dropdownActionButton: {
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(3, 2.5),
  },
  primaryButtonSm: {
    "&.MuiButton-root": {
      height: "auto",
      fontSize: 14,
      fontWeight: 500,
      [theme.breakpoints.up("lg")]: {
        padding: theme.spacing(1.25, 2.5),
        borderRadius: 30,
      },
      "&:hover, &:focus": {
        backgroundColor: theme.palette.primary.main,
        boxShadow:
          "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
      },
    },
  },
  companyContainer: {
    whiteSpace: "nowrap",
    "& .MuiButton-root": {
      maxWidth: "100%",
    },
  },
  headerRightMenuMobile: {
    "& .MuiButton-label": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "150px",
      whiteSpace: "nowrap",
      display: "block",
      [theme.breakpoints.up("sm")]: {
        overflow: "unset",
        textOverflow: "unset",
        maxWidth: "unset",
        whiteSpace: "unset",
        display: "unset",
      },
    },
  },
  headerRightMenuIcon: {
    marginLeft: "15px!important",
    [theme.breakpoints.down("sm")]: {
      verticalAlign: "middle",
    },
  },
  headerRightMenuLight: {
    color: '#ffffff',
  },
  active: {
    backgroundColor: "rgba(241,242,246, 1)",
    display: "block",
    "& .MuiTypography-root": {
      color: "#242A38!important",
    },
  },
  dateSet: {
    display: "flex",
    alignItems: "center",
    width: "50%",
    fontSize: 14,
    fontWeight: 500,
    color: "rgb(36, 42, 56)",
    borderRadius: 18,
    padding: 0,
    cursor: "pointer",
    [theme.breakpoints.up("md")]: {
      backgroundColor: "rgb(241, 242, 246)",
      padding: theme.spacing(1, 2),
      whiteSpace: "nowrap",
    },
  },
  dateSetMobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& > div": {
      width: "50%",
      maxWidth: "50%",
      flex: "0 0 50%",
      padding: theme.spacing(0.5),
    },
  },
  dateSetMobileDate: {},
  dateSetMobileMonth: {
    fontSize: 10,
  },
  dateSetIcon: {
    marginLeft: theme.spacing(1),
    cursor: "pointer",
    width: 16,
    display: "flex",
    alignItems: "center",
    "& img": {
      width: "100%",
    },
  },
  mobileSubHeader: {
    margin: theme.spacing(0),
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1),
    background: "rgba(0,0,0,.1)",
    fontSize: 12,
    fontWeight: 500,
  },
  badge: {
    cursor: "pointer",
  },
  copyrightText: {
    textAlign: "center",
    margin: "40px 0px 20px",
    color: "rgb(78,80,83)",
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
    },
  },
  helpIcon: {
    cursor: "pointer",
    width: 20,
    height: 20,
    minWidth: 20,
    backgroundColor: theme.palette.primary.main,
    color: "rgb(255,251,222)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      width: 18,
      height: 18,
      minWidth: 18,
      marginRight: theme.spacing(0),
    },
  },

  "@keyframes pulse": {
    "0%": {
      border: "0 solid rgb(253,209,39)",
      opacity: 1,
    },
    "100%": {
      border: "28px solid rgb(253,209,39)",
      opacity: 0,
    },
  },
  "@-webkit-keyframes pulse": {
    "0%": {
      border: "0 solid rgb(253,209,39)",
      opacity: 1,
    },
    "100%": {
      border: "28px solid rgb(253,209,39)",
      opacity: 0,
    },
  },

  helpIconPulse: {
    borderRadius: "50%",
    width: "0",
    height: "0",
    position: "absolute",
    animation: "$pulse 2.5s linear infinite",
  },

  popUpOuter: {
    position: "fixed",
    zIndex: 999999999,
    backgroundColor: "rgba(0,0,0,0.7)",
    width: "100vw",
    height: "100vh",

    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

  },
  popUpInner: {
    position: "absolute",
    backgroundColor: "rgb(255,255,255)",
    width: "80%",
    height: "80%",
    overflowY: "hidden",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
    },
  },
  helpPopUpContainer: {
    height: "100%",
    position: "relative",
  },
  popUpCloseIcon: {
    color: "rgb(133, 133, 132)",
    cursor: "pointer",
    fontSize: "3rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  popUpImageContainer: {
    maxWidth: "45%",
    float: "right",
    maxHeight: "100%",
    marginBottom: 0,
    backgroundColor: "#f1f2f6",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    zIndex: 1,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      height: 250,
      marginTop: 70,
    },
  },
  popUpImage: {
    maxHeight: "100%",
    maxWidth: "80%",
    margin: "70px 0 30px 0",
    width: "100%",
    boxShadow: "3px 4px 7px 0px rgba(181, 181, 181, 0.5)",
    [theme.breakpoints.down("sm")]: {
      margin: 0,
    },
  },
  textContainer: {
    position: "revert",
    padding: "0 40px",
    overflowY: "auto",
    maxWidth: "55%",
    width: "55%",
    float: "left",
    height: "calc(100% - 147px)",
    maxHeight: "calc(100% - 147px)",
    marginTop: "70px",
    marginBottom: "77px",
    [theme.breakpoints.down("sm")]: {
      order: 1,
      marginTop: 20,
      width: "100%",
      maxWidth: "100%",
      maxHeight: "calc(100% - 410px)",
    },
    "& h1, h2, h3, h4, h5, h6": {
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: "18px",
      fontWeight: 500,
      margin: "15px 0 5px",
    },
    "& p, ul li, ol li": {
      color: "rgb(129,129,129)",
      fontSize: "16px",
      margin: "0 0 10px",
    },
    "&  ul li, ol li": {
      margin: "0 0 4px",
    },
  },
  textOuter: {
    marginBottom: "80px",
  },
  helpPopUpBullet: {
    borderRadius: "50%",
    width: "15px",
    height: "15px",
    backgroundColor: "rgb(233,233,234)",
    margin: "10px 5px 20px",
  },
  helpPopUpBulletSelected: {
    backgroundColor: "rgb(255,212,40)",
  },
  circleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "10%",
  },
  helpNavigationButton: {
    padding: "10px 40px",
    width: "100%",
    position: "fixed",
    left: 0,
    bottom: 0,
    backgroundColor: "#fff",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  helpPrev: {
    backgroundColor: "rgb(255,211,40)",
    display: "inline-block",
    color: "rgb(36,42,56)",
    fontSize: "1.3rem",
    padding: "10px 25px 8px",
    borderRadius: "50px",
    cursor: "pointer",
    marginRight: "30px",
    transition: "all 0.4s ease-in-out",
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  helpNext: {
    backgroundColor: "rgb(255,211,40)",
    display: "inline-block",
    color: "rgb(36,42,56)",
    fontSize: "1.3rem",
    padding: "10px 25px 8px",
    borderRadius: "50px",
    cursor: "pointer",
    marginRight: "30px",
    transition: "all 0.4s ease-in-out",
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  disabledButton: {
    color: "rgb(175,175,175)",
    backgroundColor: "rgba(175,175,175,.1)",
  },
  slide: {
    maxWidth: "100%",
    height: "100%",
    position: "relative",
  },
  slideHide: {
    display: "none",
  },
  slideShow: {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexWrap: "wrap",
    },
  },
  contentLayoutTitle: {
    fontSize: "20px!important",
    fontWeight: 500,
    margin: "0!important",
  },
  driverAvatar: {
    color: "#5b5a5a",
    backgroundColor: "#e6ebf1",
    width: "80px",
    height: "80px",
    fontSize: "35px",
    fontWeight: 500,
    paddingTop: "8px",
    marginBottom: "20px",
    textTransform: 'uppercase',
  },
  avatarProfileLink: {
    display: 'flex',
    flexDirection: "column",
    width: "100%",
    textDecoration: "none",
    alignItems: "center",
    "&:hover": {
      textDecoration: "none",
    },
  },
  avatarProfileAdmin: {
    padding: "20px 30px!important",
  },
  layoutProfileMenu: {
    "& .MuiMenu-list": {
      padding: "unset",
    },
    "& .MuiPopover-paper": {
      marginTop: "65px",
    },
  },
  avatarProfile: {
    flexDirection: "column",
    padding: "20px 30px 10px",
    width: "250px",
    "&:hover": {
      backgroundColor: "#fff",
      cursor: "pointer",
    },
  },
  slideNumber: {
    display: "inline-block",
    color: "rgb(175, 175, 175)",
    fontSize: "15px",
    padding: "30px",
    marginTop: "10px",
  },
  title: {
    fontSize: "20px!important",
    fontWeight: 500,
    margin: "0 0 30px 0!important",
  },

  popUpHeader: {
    padding: "10px",
    position: "fixed",
    width: "100%",
    height: "70px",
    zIndex: 2,
    ['@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)']: {
      position: "static",
    },
  },
  avatarUserName: {
    fontWeight: 500,
    fontSize: "14px",
    textTransform: 'capitalize',
  },
  avatarEmail: {
    color: "rgb(175, 179, 187)",
    fontSize: "12px",
    textTransform: "lowercase",
    padding: "5px 0",
  },
  adminLink: {
    borderTop: "1px solid rgb(230, 235, 241)",
    borderBottom: "1px solid rgb(230, 235, 241)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: "15px",
    paddingBottom: "15px",
    "& span": {
      paddingTop: "2px",
      fontSize: "12px",
      fontWeight: 500,
    },
  },
  avatarLogout: {
    marginTop: "10px",
    marginBottom: "9px",
  },
  closeWindow: {
    backgroundColor: "#e6ebf1",
    fontSize: "18px",
    padding: "20px",
    height: "50px",

    minWidth: "10px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    borderRadius: "30px",
    marginLeft: "20px",
    "& .MuiButton-endIcon": {
      marginLeft: "15px",

    }
  },
  closeWindowIpad: {
    backgroundColor: "#e6ebf1",
    marginLeft: "20px",
  },
  innerTextContainer: {},
  groupNamesMenu: {
    borderRadius: '14px',
    minWidth: '300px'
  },
  selectedGroupName: {
    color: 'rgba(249, 208, 55)',
    fontSize: '14px',
    fontWeight: 500,
  },
  groupNameItem: {
    color: 'rgba(0, 0, 0)',
    fontSize: '14px',
    fontWeight: 500,
    cursor: "pointer"
  },
  childCount: {
    color: 'rgba(0, 0, 0)',
    fontSize: '10px',
    fontWeight: 300,
  },
  childCountBackground: {
    backgroundColor: 'rgb(216, 216, 216)',
    height: '13px',
    maxWidth: '13px',
    minWidth: '13px',
    marginRight: '10px',
    borderRadius: '2px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px',
    cursor: "pointer"
  },
  expandLessAndMore: {
    cursor: "pointer"
  },
  groupList: {
    padding: "0px"
  },
  selectedListItem: {
    background: "#dcdcdc"
  },
  selectedDropDown: {
    borderLeft: "1px solid rgba(224, 227, 232)",
    marginLeft: "16px",
  }
}));
